import { ASYNC_REQUEST_CLEAR_STATUS } from '../constants/constants';
import { popupOpen, popupClosed } from '../reducers/pop-ups';

export { popupOpen };

export function popUpClose(){
  return dispatch => {
    dispatch({ type: ASYNC_REQUEST_CLEAR_STATUS });
    dispatch(popupClosed());
  };
}
